import type { IMeasurementViewModel } from '@/engine/app/interfaces';
import { MeasurementKind } from '@/engine/app/interfaces';

import type { ViewEntity } from '@/engine/app/models/viewEntity/view.entity';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import { createValueAlgorithmBuilder } from '@/engine/PlanningAlgorithm/CustomMeasurementsAlgorithmBuilders';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type * as DT from '@/engine/PlanningAlgorithm/DataTypes';
import type { ViewsService } from '@/engine/app/Views.service';
import { runInAction } from 'mobx';

export class AddDiameterCommand implements ICommand {
  private _targetView: ViewEntity;

  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _descriptor: string;

  private readonly _areaModel: DT.AreaMeasurement;

  private readonly _viewsService: ViewsService;

  private readonly _viewModel: IMeasurementViewModel;

  public constructor(
    view: ViewEntity,
    descriptor: string,
    model: DT.AreaMeasurement,
    viewModel: IMeasurementViewModel,
    planningAlgorithm: PlanningAlgorithm,
    viewsService: ViewsService
  ) {
    this._targetView = view;
    this._planningAlgorithm = planningAlgorithm;
    this._descriptor = descriptor;
    this._areaModel = model;
    this._viewsService = viewsService;
    this._viewModel = viewModel;
  }

  public async execute(): Promise<boolean> {
    await this._planningAlgorithm.extendAlgorithmAsync(
      createValueAlgorithmBuilder(this._descriptor, this._areaModel),
      this._descriptor
    );
    const measurementBoxes = this._targetView.getMeasurementBoxes();
    const diametersBox = measurementBoxes?.find((box) => box.kind === MeasurementKind.AreaDiameter);
    if (diametersBox !== undefined) {
      runInAction(() => {
        diametersBox.measurements.push(this._viewModel);
      });
    }
    this._viewsService.addMeasurementToCurrentView(this._viewModel);

    return true;
  }

  public async undo(): Promise<undefined> {
    this._viewsService.removeFromViewByDescriptor(this._descriptor);
    await this._planningAlgorithm.dropAlgorithmExtensionAsync(this._descriptor);

    const measurementBoxes = this._viewsService.currentView?.getMeasurementBoxes();
    const diametersBox = measurementBoxes?.find((box) => box.kind === MeasurementKind.AreaDiameter);
    if (diametersBox) {
      const idx = diametersBox.measurements.indexOf(this._viewModel);
      if (idx > -1) {
        runInAction(() => {
          diametersBox.measurements.splice(idx, 1);
        });
      }
    }
  }
}
